module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "reservation-modal payment dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "bg-lighter",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "w-100 px-4 pt-4 bg-lightest"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex flex-row justify-content-between"
  }, [_c('label', [_vm._v("Select payment method")]), _vm._v(" "), _c('label', [_vm._v("Amount"), _c('span', {
    staticClass: "color-6 bold"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mt-3 pb-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9 d-flex flex-row flex-wrap"
  }, [_c('payment-method-picker', {
    model: {
      value: (_vm.payment.type),
      callback: function($$v) {
        _vm.$set(_vm.payment, "type", $$v)
      },
      expression: "payment.type"
    }
  })], 1), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('div', {
    staticClass: "col-sm-3 d-flex justify-content-center"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "col-sm-3 d-flex align-items-start"
  }, [_c('div', {
    staticClass: "d-flex flex-row align-items-center w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.formattedPaymentValue),
      expression: "formattedPaymentValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "fs-largest flex-grow-1 text-right bg-lighter glued-right",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "min": "0",
      "step": "0.01",
      "placeholder": "0.00"
    },
    domProps: {
      "value": (_vm.formattedPaymentValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formattedPaymentValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "border-light glued-left fs-largest py-2 px-2"
  }, [_vm._v("€")]), _vm._v(" "), (_vm.direction == 0) ? _c('span', [(!_vm.payment.value || _vm.payment.value == 0) ? _c('i', {
    staticClass: "ico ico-add fs-large light mr-0 ml-3 pointer"
  }) : _c('i', {
    staticClass: "ico ico-add fs-large color-1 mr-0 ml-3 pointer",
    on: {
      "click": function($event) {
        return _vm.addThisPayment()
      }
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex align-items-end mb-2 justify-content-end"
  }, [_c('div', [_c('label', {
    staticClass: "mr-3"
  }, [(_vm.totalDue >= 0) ? _c('span', [(_vm.reservation.changeStatusTo == '-5' || _vm.reservation.changeStatusTo == '-6') ? _c('span', [_vm._v("Value to refund")]) : _c('span', [_vm._v("Due to Pay")])]) : _vm._e(), _vm._v(" "), (_vm.totalDue < 0) ? _c('span', [_vm._v("Over Pay")]) : _vm._e()]), _vm._v(" "), (_vm.getReservationCreation) ? _c('span', {
    staticClass: "fs-large font-weight-600 pointer",
    class: {
      'color-6': (_vm.outstandingAmout - _vm.valueOfPaymentsInMemory) < 0,
      'color-3': (_vm.outstandingAmout - _vm.valueOfPaymentsInMemory) == 0
    },
    on: {
      "click": function($event) {
        _vm.copyValueToInput(_vm.formatPrice(_vm.outstandingAmout - _vm.valueOfPaymentsInMemory))
      }
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.outstandingAmout - _vm.valueOfPaymentsInMemory)) + " €")]) : _c('span', {
    staticClass: "fs-large font-weight-600 pointer",
    class: {
      'color-6': (_vm.totalDue - _vm.valueOfPaymentsInMemory) < 0,
      'color-3': (_vm.totalDue - _vm.valueOfPaymentsInMemory) == 0
    },
    on: {
      "click": function($event) {
        _vm.copyValueToInput(_vm.formatPrice(_vm.totalDue - _vm.valueOfPaymentsInMemory))
      }
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.totalDue - _vm.valueOfPaymentsInMemory)) + " €")]), _vm._v(" "), _c('label', {
    staticClass: "mx-3"
  }, [_vm._v("\n                        Total\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600 pointer",
    on: {
      "click": function($event) {
        _vm.copyValueToInput(_vm.formatPrice(_vm.getReservationCalculations.grandTotal))
      }
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotal)) + " €")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 row mx-0 px-0 py-2 border-top-light"
  }, [(_vm.direction == 1) ? _c('div', {
    staticClass: "col-sm-12 d-flex align-items-center mb-2"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("\n                        Payout reason"), _c('span', {
    staticClass: "color-6 bold"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getPayoutReasons,
      "disabled": false,
      "label": "text",
      "placeholder": "Select reason"
    },
    on: {
      "input": _vm.reasonChanged
    },
    model: {
      value: (_vm.selectedReason),
      callback: function($$v) {
        _vm.selectedReason = $$v
      },
      expression: "selectedReason"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex align-items-center"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("\n                        Notes\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.description),
      expression: "payment.description"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payment.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.paymentsInMemory.length != 0) ? _c('ul', {
    staticClass: "bg-lighter p-2 m-2 mb-3 radius-normal",
    staticStyle: {
      "border": "1px solid rgb(197, 208, 222)",
      "list-style-type": "disc",
      "padding-left": "40px !important"
    }
  }, [_c('strong', {
    staticStyle: {
      "margin-left": "-28px",
      "margin-bottom": "5px",
      "display": "block"
    }
  }, [_vm._v("Parceled payments:")]), _vm._v(" "), _vm._l((_vm.paymentsInMemory), function(payment, i) {
    return _c('li', {
      key: i
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.parceledPaymentRow(payment))
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times fs-large light ml-2 pointer",
      on: {
        "click": function($event) {
          return _vm.$delete(_vm.paymentsInMemory, i)
        }
      }
    })])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel widest",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok widest",
    attrs: {
      "type": "button",
      "disabled": _vm.disabledSaveBtn
    },
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.getReservationCreation) ? _c('button', {
    staticClass: "btn blue ok widest",
    attrs: {
      "type": "button",
      "disabled": _vm.disabledSaveBtn
    },
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._v("Save and print")]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3760ba63", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3760ba63"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayment.vue
// module id = 1982
// module chunks = 0